import type { DeltaMode } from "@/hooks/useDeltaMode";
import { t } from "@/i18n";

interface DeltaModeToggleProps {
  mode: DeltaMode;
  onChange: (mode: DeltaMode) => void;
}

const MODES: DeltaMode[] = ["pct", "value"];

/** Δ rozetleri "% Fark" / "Değer Farkı" secici — legacy `#deltaModeTabs` portu
 * (madde D). Kontrollu bilesen: durum `useDeltaMode()` sahibi sayfada tutulur. */
export function DeltaModeToggle({ mode, onChange }: DeltaModeToggleProps) {
  return (
    <div role="tablist" aria-label={t("delta.mode.title")} className="inline-flex gap-1 rounded-lg bg-bg p-1">
      {MODES.map((m) => {
        const selected = m === mode;
        return (
          <button
            key={m}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(m)}
            className={`min-h-[44px] rounded-md px-3 text-xs font-medium transition-colors ${
              selected ? "bg-card text-brand-primary shadow-sm" : "text-muted hover:text-ink"
            }`}
          >
            {t(m === "pct" ? "delta.mode.pct" : "delta.mode.value")}
          </button>
        );
      })}
    </div>
  );
}
